import React from 'react';
import {
  Container,
  Typography,
  Box
} from '@mui/material';
import { Devices } from '@mui/icons-material';
import DeviceConnectionCardV2 from '../components/DeviceConnection/DeviceConnectionCardV2';

const DevicesPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Devices />
          Connected Devices
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage your fitness device connections and sync your activity data
        </Typography>
      </Box>

      <DeviceConnectionCardV2 />
    </Container>
  );
};

export default DevicesPage;